import axios from "axios";
import Config from "../config/index";
import authHeader from "@/services/auth-header";

class ActivityService {
    async getPaginatedActivityLogs(param) {
        const response = await axios.get(
            Config.apiBasePath + "/get-activities-paginated",
            {headers: authHeader(), params: param}
        );
        return response.data;
    }
}

export default new ActivityService();
